export const baseURL = "https://connect-admin-andn.onrender.com/";
export const secretKey = "connect123";
export const projectName = "flingy";
